/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilityFilters extends models.SecurityInfraDashboardBaseFilters {
    getFixupPrototypeFunction() { return ThreatVulnerabilityFilters.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilityFilters>): ThreatVulnerabilityFilters {
        let obj = Object.assign(new ThreatVulnerabilityFilters(), model);
        ThreatVulnerabilityFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilityFilters>): ThreatVulnerabilityFilters {
        if (!model) return null;
        return ThreatVulnerabilityFilters.newInstance(<ThreatVulnerabilityFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilityFilters) {
        if (!obj) return;

        models.ThreatVulnerabilityFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilityFilters): boolean {
        if (models.SecurityInfraDashboardBaseFilters.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatVulnerabilityFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Search text to filter the threats/vulnerabilities based on Resource Name, Resource ID, Findings ID
     */
    search: string;

}
